import React from 'react'
import {Image,Header,Icon,Label } from 'semantic-ui-react'
import mainlogo from './logoMav600.jpg'
import bandeau from './bandeau_expertise_mav.jpg'

const Mainheader = ()=>(
<div>
  <div className='mainheader'>
      <div className='dealerLogo'>
        <Image src={mainlogo} size='small'/>
        <Label>
          <Icon name='phone' />06 78 30 64 89
        </Label>
        
      </div>
      <div className='maintitle'>
        <Header as='h2' icon>
          <Icon name='eur' />
            vous propose un prix d'achat
          <Header.Subheader>
            en 48 heures
          </Header.Subheader>
        </Header>
      </div>
  </div>
  <div className='bandeau'>
    <Image src={bandeau}/>
  </div>
</div>

)
  


export default Mainheader